import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CognitoService } from 'app/core/http/services/cognito.service';

@Component({
  selector: 'page-practioner-registration',
  templateUrl: './practioner-registration.component.html',
  styleUrls: ['./practioner-registration.component.scss'],
})
export class OrganizationPractitionerLinkComponent implements OnInit {
  public loading = false;
  public submitted = false;
  public successLogin = false;
  public form!: FormGroup;
  public hide: Boolean = true;
  public title = 'Cadastrar um especialista';

  public messageError = ''
  public messageSuccess = ''
  
  public showSuccessMessage = false
  public showErrorMessage = false

  constructor(private fb: FormBuilder, private router: Router, private cognitoService: CognitoService) {}

  validatePassword(control: AbstractControl): { [key: string]: boolean } | null {
    const password = control.value;
    const hasNumber = /[0-9]/.test(password);
    const hasUpper = /[A-Z]/.test(password);
    const hasLower = /[a-z]/.test(password);
    const hasSpecial = /[^\w\s]/.test(password);

    if (!hasNumber || !hasUpper || !hasLower || !hasSpecial) {
      return { invalidPassword: true };
    }

    return null;
  }

  ngOnInit(): void {
    this.form = this.fb.group(
      {
        email: new FormControl(null, [Validators.required, Validators.email]),
        password: new FormControl(null, [Validators.required, this.validatePassword]),
        password_confirmation: new FormControl(null, [Validators.required]),
        type: new FormControl('practitioner', [Validators.required]),
      },
      { validators: this.matchPassword }
    );
  }

  register() {
    if (this.form.invalid) {
      this.submitted = true;
      this.successLogin = false;
      return;
    }

    const formData = this.form.value;

    this.submitted = true;

    this.cognitoService
      .signUp(formData)
      .then((response) => {
        this.messageSuccess = 'Usuário cadastrado com sucesso! O novo usuário receberá um e-mail com instruções para confirmar o acesso'
        this.showSuccessMessage  = true
        this.showErrorMessage  = false
      })
      .catch((error) => {
        this.successLogin = false;
        this.messageError = error.message
        this.showSuccessMessage  = false
        this.showErrorMessage  = true
      });
  }

  private matchPassword(AC: AbstractControl) {
    const password = AC.get('password')?.value;
    const confirmPassword = AC.get('password_confirmation')?.value;

    if (password !== confirmPassword) {
      AC.get('password_confirmation')?.setErrors({ mismatch: true });
      return { mismatch: true };
    }

    return null;
  }
}
